var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconInstagram(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 33,
    height: 33,
    viewBox: "0 0 33 33",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11 4.125C7.20363 4.125 4.125 7.20363 4.125 11V22C4.125 25.7964 7.20363 28.875 11 28.875H22C25.7964 28.875 28.875 25.7964 28.875 22V11C28.875 7.20363 25.7964 4.125 22 4.125H11ZM24.75 6.875C25.509 6.875 26.125 7.491 26.125 8.25C26.125 9.009 25.509 9.625 24.75 9.625C23.991 9.625 23.375 9.009 23.375 8.25C23.375 7.491 23.991 6.875 24.75 6.875ZM16.5 9.625C20.2964 9.625 23.375 12.7036 23.375 16.5C23.375 20.2964 20.2964 23.375 16.5 23.375C12.7036 23.375 9.625 20.2964 9.625 16.5C9.625 12.7036 12.7036 9.625 16.5 9.625ZM16.5 12.375C15.406 12.375 14.3568 12.8096 13.5832 13.5832C12.8096 14.3568 12.375 15.406 12.375 16.5C12.375 17.594 12.8096 18.6432 13.5832 19.4168C14.3568 20.1904 15.406 20.625 16.5 20.625C17.594 20.625 18.6432 20.1904 19.4168 19.4168C20.1904 18.6432 20.625 17.594 20.625 16.5C20.625 15.406 20.1904 14.3568 19.4168 13.5832C18.6432 12.8096 17.594 12.375 16.5 12.375Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconInstagram);
export default __webpack_public_path__ + "static/media/icon-instagram.dac3a7c2ac038610ad09b2a61843dabe.svg";
export { ForwardRef as ReactComponent };